// eslint-disable-next-line
import util from 'util';

/* Default to logging any errors */
export let defaultErrorHandler = (error) => {
  util.log(error)
};

/* Get the base URL */
export function BaseUrl() {
  return(window.location.origin + "/portalApi");
}


let sessionKey = () => {return(undefined)};
let defaultError = (statusCode, message) => util.log(message);
let defaultUnauthorized  = () => {};

/* Provide a function to get the current session key, report an error,
   and report a 401 response */
export function setup(getSessionKey, error, unauthorized) {
  sessionKey = getSessionKey;
  defaultErrorHandler = error;
  defaultUnauthorized = unauthorized;
}

/* Make a form from an object */
export function makeForm(formObject) 
{
  let form = '';
  let keyNames = Object.keys(formObject);
  for (let i=0 ; i < keyNames.length; i++) {
    if (typeof(formObject[keyNames[i]]) !== 'undefined') {
      if (i>0) {
        form += '&';
      }
      if (formObject[keyNames[i]] instanceof Date) {
        form += keyNames[i] + '=' + formObject[keyNames[i]].toISOString();
      } else {
        form += keyNames[i] + '=' + encodeURIComponent(formObject[keyNames[i]]);
      }
    }
  }
  return(form);
}

/* Get the content from a response */
function getContent(response) {
  let contentType = response.headers.get('Content-Type');
  if (contentType === 'application/json') {
    return(response.json());
  }
  return(response.text());
}

function callback(callBackupFunction, defaultFunction, status, contents, retry) {
  if (typeof(callBackupFunction) === 'function') {
    callBackupFunction(status, contents, retry);
    return;
  }
  if (typeof(defaultFunction) === 'function') {
    defaultFunction(status, contents, retry);
    return;
  }
}


/* Post a form. Passing an error or unauthorized function overrides
   calling the default */
export function post(url, form, complete, error, unauthorized) {
  
  let parameters = {
    method : 'POST',
    headers : {}
  };
    
  if (typeof(form) === 'object') {
    let encodedForm = makeForm(form);
    
    parameters.body = encodedForm;
    parameters.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  }
    
  if (Boolean(sessionKey())) {
    parameters.headers['Authorization'] = 'Bearer ' + sessionKey();    
  }
    
  fetch(BaseUrl() + url, parameters)
    .then(function (response) {
      getContent(response).then((content) => {
        if (response.ok) {
          if (typeof(complete) === 'function') {
            callback(complete, undefined, response.status, content);
          }
        } else {
          if (response.status === 401) {
            callback(unauthorized, defaultUnauthorized, response.status, content,
                     () => post(url, form, complete, error, unauthorized));
          } else {
            callback(error, defaultError, response.status, response.headers.get('X-PORTAL-ERROR'));
          }
        }});
    }).catch(function(errorEvent) {
      callback(error, defaultError, 999, errorEvent.message);
    });
}

/* Post a form. Passing an error or unauthorized function overrides
   calling the default */
export function put(url, form, complete, error, unauthorized) {

  let parameters = {
    method : 'PUT',
    headers : {}
  };

  if (typeof(form) === 'object') {
    let encodedForm = makeForm(form);

    parameters.body = encodedForm;
    parameters.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
  }

  if (Boolean(sessionKey())) {
    parameters.headers['Authorization'] = 'Bearer ' + sessionKey();
  }

  fetch(BaseUrl() + url, parameters)
      .then(function (response) {
        getContent(response).then((content) => {
          if (response.ok) {
            if (typeof(complete) === 'function') {
              callback(complete, undefined, response.status, content);
            }
          } else {
            if (response.status === 401) {
              callback(unauthorized, defaultUnauthorized, response.status, content,
                  () => post(url, form, complete, error, unauthorized));
            } else {
              callback(error, defaultError, response.status, response.headers.get('X-PORTAL-ERROR'));
            }
          }});
      }).catch(function(errorEvent) {
    callback(error, defaultError, 999, errorEvent.message);
  });
}

/* Get a record */
export function get(url, queryParameters, complete, error, unauthorized) {
  let fullUrl = BaseUrl() + url;
  if (typeof(queryParameters) === 'object') {
    fullUrl = fullUrl + '?' + makeForm(queryParameters);
  }

  let parameters = { method : 'GET', headers : {} };
  if (Boolean(sessionKey())) {
    parameters.headers['Authorization'] = 'Bearer ' + sessionKey();    
  }
  fetch(fullUrl, parameters)
    .then(function (response) {
      getContent(response).then((content) => {
        if (response.ok) {
          if (typeof(complete) === 'function') {
            callback(complete, undefined, response.status, content);
          }
        } else {
          if (response.status === 401) {
            callback(unauthorized, defaultUnauthorized, response.status, content,
                     () => get(url, queryParameters, complete, error, unauthorized));
          } else {
            callback(error, defaultError, response.status, response.headers.get('X-PORTAL-ERROR'));
          }
        }});
    }).catch(function(errorEvent) {
      callback(error, defaultError, 999, errorEvent.message);
    });
}
